// Package imports
import React, { } from "react";

import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Typography from '@mui/material/Typography';

import { makeStyles } from "@material-ui/core/styles";
import IconButton from "@mui/material/IconButton";
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { joinByKeys } from "../../../Js/Common";
import { getFormatedDate } from "../../../Js/TimeAndDate";
import Fade from '@mui/material/Fade';

const AssignmentReportCard = (props) => {
    const classes = useStyles();
    // JSX template
    return (
        <Fade in={true} timeout={500}>
        <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
            <Card
                className={classes.card}
                sx={{ boxShadow: "4px 4px 10px 0px #E5E5E5", cursor: 'pointer', py: 2,position: 'relative' }}
                onClick={() => {
                    props.press();
                }}
            >
                <CardContent sx={{ py: 1, }}>
                    <Typography
                        className={classes.ModuleName}
                        sx={{color:"#5f5600ff"}}
                    >
                        {props.reportData.title}
                    </Typography>
                    <Typography
                        className={classes.cardText}
                        sx={{ color:"#5f5600ff", marginBottom: 2, borderBottom: 1, borderColor: "#D9D9D9", pb: 2 }}
                    >
                        Trainer: {joinByKeys(props.reportData.name, ['firstname', 'lastname'], ' ')}
                    </Typography>
                    {(props.roleData.title.toLowerCase() != 'learner') &&
                        <>
                            {/* <Typography
                                className={classes.cardText}
                                sx={{ color: "#064b00ff", textAlign: 'justify' }}>
                                Total Learner: {props.reportData.totallearners}
                            </Typography> */}
                            <Typography
                                className={classes.cardText}
                                sx={{ color: "#064b00ff" }}>
                                Total Attempted: {props.reportData.attemptedlearners}
                            </Typography>
                        </>
                    }
                    {/* <Typography
                        className={classes.classDate}
                        sx={{ color: '#F5F7FF', border: 1, borderColor: '#C4CBE7' }}>
                        {getFormatedDate(props.reportData.commences)} - {getFormatedDate(props.reportData.expiries)}
                    </Typography> */}
                </CardContent>
                {/* <CardActions sx={{justifyContent: "flex-end", py: 0, pb: 1 }}>
                    <IconButton
                        aria-label="Go"
                        size="small"
                        sx={{
                            position: 'absolute',
                            bottom: 10,
                            borderRadius: "50%",
                            backgroundColor: "#F5F5F5",
                            color: "primary.main",
                            padding: 0.5,
                            '@media (min-width: 1636px)': {
                                mt: 2
                            },
                           
                        }}
                    >
                        <NavigateNextIcon fontSize="inherit" sx={{
                            fontSize: "1.5rem",
                            '@media (min-width: 1636px)': {
                                fontSize: "2.2rem"
                            },
                        }} />
                    </IconButton>
                </CardActions> */}
            </Card>
        </Box>
         </Fade>
    );
};
const useStyles = makeStyles({
    card: {
        background: "linear-gradient(135deg, rgba(180,227,145,1) 0%,rgba(97,196,25,1) 50%,rgba(180,227,145,1) 100%);",
        width: "14rem",
        height: '10rem',
        borderRadius: 17,
        shadowColor: "#000",
        boxShadow: "2rem",
        '@media (min-width: 1636px)': {
            width: '18rem',
            height: '21rem'
        },
    },
    ModuleName: {        
        fontSize: "1.1rem",
        textAlign: "center",
        fontWeight: "900",      
        wordWrap: 'break-word',          
        overflow: 'hidden',
        textOverflow: "ellipsis",
        display: "-webkit-box",
        WebkitLineClamp: 2,
        WebkitBoxOrient: "vertical",
        '@media (min-width: 1636px)': {
            fontSize: "1.6rem",
        },
    },
    cardText: {
        fontSize: "0.8rem",
        textAlign: "center",
        paddingTop: 5,
        fontWeight: "500",
        '@media (min-width: 1636px)': {
            fontSize: "1.2rem",
            paddingTop: 10,
        },
    },
    classDate: {
        borderRadius: 20,
        textAlign: "center",
        color: "#C4CBE7",
        fontSize: "0.7rem",
        marginTop: 10,
        marginLeft: 10,
        marginRight: 10,
        fontWeight: "600",
        '@media (min-width: 1636px)': {
            fontSize: "1.2rem"
        },
    },
});
export default AssignmentReportCard;